import {createSlice,createAsyncThunk} from '@reduxjs/toolkit';

export const fetchAuditEvents = createAsyncThunk(
  "audit/fetchAuditEvents",
  async (_, thunkAPI) => {
    try {
      const res = await fetch("/api/v1/admin/audit");

      if (!res.ok) {
        throw new Error("Failed to fetch audit events");
      }

      return await res.json();
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

const auditSlice = createSlice({
  name: 'audit',

  initialState: {
    events: [],
    loading: false,
    loaded: false,
    error: null
  },

  reducers: {
      addAuditEvent: (state, action) => {
        const exists = state.events.some(
          e => e.id === action.payload.id
        );

        if (!exists) {
          state.events.unshift(action.payload);
        }
      }
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchAuditEvents.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(fetchAuditEvents.fulfilled, (state, action) => {
        state.loading = false;
        state.loaded = true;
        state.events = action.payload;
      })

      .addCase(fetchAuditEvents.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { addAuditEvent } = auditSlice.actions;

export const selectAuditEvents = (state) => state.audit.events;
export const selectAuditLoading = (state) => state.audit.loading;
export const selectAuditError = (state) => state.audit.error;

export default auditSlice.reducer;